import { FilterConfigFixed } from '@/types/filter';

// Disabled until the Account Planning cube dimension exists; applies no filter yet.
const hcoAccountPlanningCompletedFilter: FilterConfigFixed = {
  label: 'global.filters.formControls.hcoAccountPlanningCompletedLabel',
  type: 'checkbox',
  defaultValue: false,
  clearable: false,
  searchable: false,
  comingSoon: true,
  disabled: true,
  format: ({ value, t }) => {
    if (value) return t('global.filters.formControls.hcoAccountPlanningCompletedLabel');
    return '';
  },
  applyFilter: () => undefined,
};

export default hcoAccountPlanningCompletedFilter;
